import {useSnackbar} from 'notistack';
import {Button} from '../common/Button';
import {useCallback} from 'react';

const ActionButton = ({buttonId}) => {
  const {closeSnackbar} = useSnackbar();

  const onClose = useCallback(() => {
    closeSnackbar(buttonId);
  }, [buttonId]);

  return (
    <Button onClick={onClose} label="Dismiss" color="inherit" variant="text" />
  );
};

export default ActionButton;
